/** Copyright 2026 Midas Healthcare Solutions - All Rights Reserved **/
import { SettingsGroups, User, UserAlibiSettings } from '@midas/shared/common';
import { createFeature, createReducer, on } from '@ngrx/store';
import * as UserActions from './user.actions';
import merge from 'lodash.merge';

export const USER_KEY = 'user';

export interface UserState extends User {
  loaded: boolean;
}

const initialState = { loaded: false } as UserState;

export const UserFeature = createFeature({
  name: USER_KEY,
  reducer: createReducer(
    initialState,
    on(UserActions.getProfileSuccess, (state, { user }): UserState => {
      return { ...state, ...user, loaded: true };
    }),
    on(UserActions.refreshProfile, (state): UserState => {
      return { ...state, loaded: false };
    }),
    on(UserActions.verifyUserSmsMfaSuccess, (state, { user }): UserState => {
      return { ...state, ...user };
    }),
    on(UserActions.verifyDisableUserMfaSuccess, (state, { user }): UserState => {
      return { ...state, ...user };
    }),
    on(UserActions.updateProfileSuccess, (state, user): UserState => {
      return { ...state, ...user, loaded: false };
    }),
    on(UserActions.recordAlibiLoginSuccess, (state, { success }): UserState => {
      return { ...state, hasLoggedIntoAlibi: success };
    }),
    on(UserActions.updateUserNotificationsSuccess, (state, { user }): UserState => {
      return { ...state, ...user };
    }),
    on(UserActions.updateUserAlibiSettings, (state, { settingsGroup, settingsJson }): UserState => {
      let newAlibiSettings: UserAlibiSettings[];

      if (state.alibiSettings.findIndex((s) => s.settingsGroup === settingsGroup) >= 0) {
        if (settingsGroup === SettingsGroups.GeneralSettings) {
          const generalSettings = state.alibiSettings.find(
            (s) => s.settingsGroup === SettingsGroups.GeneralSettings,
          );
          if (generalSettings) {
            const current = JSON.parse(generalSettings.settings);
            const incoming = JSON.parse(settingsJson);
            const merged = merge(current, incoming);

            settingsJson = JSON.stringify(merged);
          }
        }

        newAlibiSettings = state.alibiSettings.map((s) =>
          s.settingsGroup === settingsGroup ? { ...s, settings: settingsJson } : s,
        );
      } else {
        newAlibiSettings = [...state.alibiSettings, { settingsGroup, settings: settingsJson }];
      }

      return { ...state, alibiSettings: newAlibiSettings };
    }),
    on(UserActions.setProfilePictureUploadCompleteSuccess, (state, { version }): UserState => {
      return { ...state, profilePictureVersion: version };
    }),
    on(UserActions.deleteProfilePictureSuccess, (state): UserState => {
      return { ...state, profilePictureVersion: null };
    }),
  ),
});
